import { Alert } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

interface ProductTestExistsAlertProps {
  lotNumber: string
  batchNumber: string | null
}

export const ProductTestExistsAlert: FC<ProductTestExistsAlertProps> = ({ lotNumber, batchNumber }) => (
  <Alert
    icon={<WarningOutlined className='text-[#EF6C00]' />}
    severity='warning'
    variant='filled'
    color='warning'
    className='bg-[#FFF4E5] text-[#663C00]'
  >
    Test data for product with lot number {lotNumber} and batch number {batchNumber} already exists.
  </Alert>
)
